import { BodyM } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import React, { MutableRefObject } from 'react'

import { ModalMap } from '@/components/Modal/Types/Map'
import { CardPoi } from '@/components/poi/CardPoi'
import { ContextValue } from '@/context/Cities'
import { useModal } from '@/context/ModalContext'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ListingCate } from '@/page-commons/listingBySlug'
import { MapPoi, PoiCategory } from '@/types/poi'
import { handleClickOpenMap, handleListingDetailMapClick } from '@/utils/tracking/eventsHandlers'

type Props = {
  cities: ContextValue
  closestPointsOfInterest: MapPoi[]
  handleTrackingCallAgency: (eventCategory: string) => void
  listing: ListingCate
  onOpenDetailFormModal: (reopenMap: boolean) => (event: React.SyntheticEvent<HTMLElement>) => void
  pointsOfInterest: MapPoi[]
  similarPropertiesRef: MutableRefObject<HTMLDivElement>
}

const Nearby: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { closeModal, openModal } = useModal()

  const handleNearbyCardClick = (filter: PoiCategory) => {
    openModal(
      <ModalMap
        cities={props.cities}
        closeModal={closeModal}
        closestPointsOfInterest={props.closestPointsOfInterest}
        filter={filter}
        handleOpenDetailFormModal={props.onOpenDetailFormModal(true)}
        handleTrackingCallAgency={props.handleTrackingCallAgency}
        listing={props.listing}
        pointsOfInterest={props.pointsOfInterest}
        selectedMarker={null}
        similarPropertiesRef={props.similarPropertiesRef}
      />
    )
    handleClickOpenMap('ListingDetail')
    handleListingDetailMapClick(`PoiButton${filter}`)
  }

  return (
    <div className={sprinkles({ marginBottom: '2xl' })} data-testid="nearby-pois">
      <BodyM strong className={sprinkles({ paddingBottom: 'l' })} color="greyscale600">
        {t('listing-detail:poi_nearby')}
      </BodyM>
      <div className={sprinkles({ display: 'flex', flexDirection: { desktop: 'row', mobile: 'column' } })}>
        {props.closestPointsOfInterest.map((poi, index) => (
          <CardPoi key={index} openMap={handleNearbyCardClick} poi={poi} />
        ))}
      </div>
    </div>
  )
}

export default Nearby
